var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThemesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.596 4.38v4.087a4.085 4.085 0 0 1-4.086 4.086H4.423A4.085 4.085 0 0 1 .337 8.467V4.38A4.085 4.085 0 0 1 4.423.294H8.51a4.085 4.085 0 0 1 4.086 4.086z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ff9500",
    d: "M12.596 18.682v4.087a4.085 4.085 0 0 1-4.086 4.086H4.423A4.085 4.085 0 0 1 .337 22.77v-4.087a4.085 4.085 0 0 1 4.086-4.086H8.51a4.085 4.085 0 0 1 4.086 4.086z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#a6d2ff",
    d: "M12.596 32.985v4.086a4.085 4.085 0 0 1-4.086 4.086H4.423a4.085 4.085 0 0 1-4.086-4.086v-4.086a4.085 4.085 0 0 1 4.086-4.087H8.51a4.085 4.085 0 0 1 4.086 4.087z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#757575",
    d: "M26.898 4.38v4.087a4.085 4.085 0 0 1-4.086 4.086h-4.087a4.085 4.085 0 0 1-4.086-4.086V4.38A4.085 4.085 0 0 1 18.725.294h4.087a4.085 4.085 0 0 1 4.086 4.086z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffd60a",
    d: "M26.898 18.682v4.087a4.085 4.085 0 0 1-4.086 4.086h-4.087a4.085 4.085 0 0 1-4.086-4.086v-4.087a4.085 4.085 0 0 1 4.086-4.086h4.087a4.085 4.085 0 0 1 4.086 4.086z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3f90d8",
    d: "M26.898 32.985v4.086a4.085 4.085 0 0 1-4.086 4.086h-4.087a4.085 4.085 0 0 1-4.086-4.086v-4.086a4.085 4.085 0 0 1 4.086-4.087h4.087a4.085 4.085 0 0 1 4.086 4.087z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ff453a",
    d: "M41.2 4.38v4.087a4.085 4.085 0 0 1-4.086 4.086h-4.086a4.085 4.085 0 0 1-4.087-4.086V4.38A4.085 4.085 0 0 1 33.028.294h4.086A4.085 4.085 0 0 1 41.2 4.38z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#32d74b",
    d: "M41.2 18.682v4.087a4.085 4.085 0 0 1-4.086 4.086h-4.086a4.085 4.085 0 0 1-4.087-4.086v-4.087a4.085 4.085 0 0 1 4.087-4.086h4.086a4.085 4.085 0 0 1 4.086 4.086z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#af52de",
    d: "M41.2 32.985v4.086a4.085 4.085 0 0 1-4.086 4.086h-4.086a4.085 4.085 0 0 1-4.087-4.086v-4.086a4.085 4.085 0 0 1 4.087-4.087h4.086a4.085 4.085 0 0 1 4.086 4.087z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemesIcon);
export default __webpack_public_path__ + "static/media/themesIcon.5f9d5be86d85565222296baa04bc5dae.svg";
export { ForwardRef as ReactComponent };